export enum BillItemGroupTypes {
  /** 未指定 */
  None = 0,
  /** 入会金 */
  MembershipFee = 1,
  /** 授業料 */
  TuitionFee = 2,
  /** 教材費用 */
  TeachingMaterialsFee = 3,
  /** 外部試験料 */
  ExternalExaminationFee = 4,
  /** 講習費用 */
  TrainingFee = 5,
  /** 値引き */
  DiscountFee = 6,
  /** 年間費用 */
  YearlyFee = 7,
  /** システム費用 */
  SystemCost = 8,
  /** 増加授業料 */
  IncreaseInTuitionFee = 9,
  /** その他 */
  Other = 10,
}

export function getBillItemGroupTypeName(value: BillItemGroupTypes, noneName: string = '未指定'): string {
  switch (value) {
    case BillItemGroupTypes.None: return noneName;
    case BillItemGroupTypes.MembershipFee: return '入会金';
    case BillItemGroupTypes.TuitionFee: return '授業料';
    case BillItemGroupTypes.TeachingMaterialsFee: return '教材費用';
    case BillItemGroupTypes.ExternalExaminationFee: return '外部試験料';
    case BillItemGroupTypes.TrainingFee: return '講習費用';
    case BillItemGroupTypes.DiscountFee: return '値引き';
    case BillItemGroupTypes.YearlyFee: return '年間費用';
    case BillItemGroupTypes.SystemCost: return 'システム費用';
    case BillItemGroupTypes.IncreaseInTuitionFee: return '増加授業料';
    case BillItemGroupTypes.Other: return 'その他';
  }
}

export function getBillItemGroupTypes(includeNone: boolean = true): BillItemGroupTypes[] {
  const list: BillItemGroupTypes[] = [];
  for (const item in BillItemGroupTypes) {
    if (!isNaN(Number(item))) {
      const num = Number(item);
      if (includeNone || num !== BillItemGroupTypes.None) {
        list.push(num);
      }
    }
  }
  return list;
}
